import { Typography } from "@mui/material";
import unimedLogo from '../../../assets/images/logo-unimed-campinas.png';
import { sxTypographyTelessaude } from "./sxProps";


const HeaderTelessaude: React.FC = () => {
  return (
    <>
      <img src={unimedLogo} alt="Logo Unimed Campinas"
        className='layout-unimed-logo' />
      <Typography sx={sxTypographyTelessaude}>TELESSAÚDE</Typography>
    </>
  )
}

export default HeaderTelessaude;